import { Component, signal, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
})
export class App implements OnInit {
  protected readonly title = signal('Trade Platform');
  private translateService = inject(TranslateService);

  ngOnInit(): void {
    // Set default language
    this.translateService.setDefaultLang('en-US');
    this.translateService.use('en-US');
  }
}
